import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  AntdLayout,
  COLOR_BASE_100,
  HEADER_HEIGHT,
  LAYOUT_HEIGHT,
  SAFE_AREA_HEIGHT,
  isYWC,
} from '@ui';
import { NavBar } from './NavBar';

const { Header, Content } = AntdLayout;

export interface FixedLayoutProps {
  children?: React.ReactNode;
  contentStyle?: React.CSSProperties;
  hideLinks?: boolean;
  navBar?: React.ReactNode;
}

export const FixedLayout = ({ contentStyle = {}, hideLinks = false }: FixedLayoutProps) => (
  <AntdLayout className="w-screen h-screen overflowY-hidden flex">
    <Header
      className={`bg-white border-b border-base-200 border-solid border-x-0 border-t-0
        ${isYWC ? 'h-24' : 'h-12'}
        px-4 md:px-[78px] flex justify-between items-center fixed sm:sticky z-10 w-screen`}
      style={{
        paddingTop: SAFE_AREA_HEIGHT,
        height: HEADER_HEIGHT,
      }}
    >
      <NavBar hideLinks={hideLinks} />
    </Header>

    <Content
      className="overflow-hidden flex"
      style={{
        minHeight: LAYOUT_HEIGHT,
        backgroundColor: COLOR_BASE_100,
        ...contentStyle,
      }}
    >
      <div className="flex flex-col justify-end mx-auto w-full">
        <Outlet />
      </div>
    </Content>
  </AntdLayout>
);
